import React from 'react';
import { Button, Card, CardActions, CardContent, CircularProgress, Grid, Typography } from '@mui/material';

import EtfList from '../etf_list.json';

const Info = ({ info }) => {
    const InfoCard = ({ etf }) => {
        return (
            <Grid item xs={12} sm={12} md={5}>
                <Card sx={{ maxWidth: 345 }}>
                    <CardContent align="left">
                        <Typography gutterBottom variant="h5" component="div">
                            {etf.Ticker}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {etf.Name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Fund Holdings as of: {etf['Fund Holdings as of']}
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button
                            size="small"
                            href={EtfList.find(op => op.ticker === etf.Ticker).url}
                            target="_blank"
                        >Learn More</Button>
                    </CardActions>
                </Card>
            </Grid>
        );
    }

    if (info.length === 0) {
        return (
            <CircularProgress />
        );
    } else {
        return (
        <Grid container rowSpacing={2} justifyContent="space-evenly" alignItems="center">
            <InfoCard etf={info[0]} />
            <Grid item>
                <Typography variant="overline" >- vs -</Typography>
            </Grid>
            <InfoCard etf={info[1]} />
        </Grid>
    );
    }
    
}

export default Info;

